import React, { Component } from 'react';
import SurveyItemList from '../../../../Domain/SurveyItemList';
import SurveyService from '../../../../Services/surveyService';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import GeneralEditWizzardBase from '../../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../../Enums/CrudTypesEnum';
import EditSurveyWindowDescription from './EditSurveyWindowDescription';
import AddSurveyWindowDescription from './AddSurveyWindowDescription';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import ShownOverWindowsEnum from '../../../../Enums/ShownOverWindowsEnum';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import OrderDirectionsEnum from '../../../../Enums/OrderDirectionsEnum';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import FigmaButtonRow from '../../../../Elements/FigmaButtonRow';

class SurveyAdmin extends Component {
  static defaultProps = {
    surveyDisplayType: 'Client',
  };

  constructor(props) {
    super(props);
    this.state = {
      itemList: [],
      selected: -1,
      popup: null,
      shownPanel: null,
      selectedItem: null,
      addSurveyItem: null,
      numberOfElementInList: 10,
      numberOfElementConst: 10,
      searchItem: {
        Id: this.props.clientId,
        SurveyDisplayType: this.props.surveyDisplayType,
      },
      showAll: false,
    };
    this.showPanel = this.showPanel.bind(this);
    SurveyItemList.removeFunction = this.clickOnRemoveSurvey.bind(this);
    SurveyItemList.editFunction = this.clickOnEditFunction.bind(this);
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  clickOnRemove(selectedId) {
    SurveyService.RemoveSurvey(selectedId)
      .then((result) => {
        if (result.error) ErrorMessage.SetWarning(result.error);
        else this.refresh();
      })
      .catch(() => ErrorMessage.SetErrorMessage('SA54'));
  }

  clickOnEditFunction(clickOnEselectedId, selectedItem) {
    this.setState({
      selected: selectedItem,
      shownPanel: ShownPanelsEnum.EditItem,
    });
    this.setState({ shownPanel: ShownPanelsEnum.EditItem });
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  clickOnRemoveSurvey(selectedId, selectedItem) {
    ErrorMessage.SetApprove('Are you sure you want to delete this survey?', () => this.clickOnRemove(selectedId));
    this.setState({ selected: selectedItem });
  }

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.AddNewItem && this.state.shownPanel !== ShownPanelsEnum.AddNewItem) {
      this.clickOnAddSurvey();
      return;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  clickOnAddSurvey() {
    // Inactive clients: skip the Apollo prefetch and let renderPanels' IsActive guard show the
    // "Client is Inactive!" alert - the old panel never mounted (so never fetched) in this case.
    if (this.props.IsActive === false) {
      this.setState({ shownPanel: ShownPanelsEnum.AddNewItem });
      return;
    }
    SurveyService.GetAvailableSurveyFromAppolo(this.props.clientId)
      .then((result) => {
        const availableSurveys = SurveyService.ConvertDBItem(result);
        availableSurveys.forEach((survey) => {
          survey.DisplayLabel = `${survey.Name} (${survey.SassieId})`;
        });
        this.setState({
          shownPanel: ShownPanelsEnum.AddNewItem,
          addSurveyItem: { AvailableSurveys: availableSurveys, SelectedSurveyIds: [], SelectedRows: [] },
        });
      })
      .catch(() => ErrorMessage.SetErrorMessage('ASP47'));
  }

  renderPanels() {
    if (
      this.props.IsActive === false &&
      (this.state.shownPanel === ShownPanelsEnum.AddNewItem || this.state.shownPanel === ShownPanelsEnum.EditItem)
    ) {
      return (
        <div
          className='alert alert-danger'
          role='alert'
        >
          Client is Inactive!
        </div>
      );
    }
    if (this.state.shownPanel === ShownPanelsEnum.Details) {
      this.ClickOnSelectAllButton();
      return null;
    }
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.addSurveyItem}
            clickOnCancel={() => {
              this.setState({ shownPanel: ShownPanelsEnum.None });
            }}
            clickOnSave={() => {
              this.setState({ shownPanel: ShownPanelsEnum.None });
              this.refresh();
            }}
            windowDescription={AddSurveyWindowDescription}
            errorCode='SUR-APPLY'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selected}
            clickOnCancel={() => {
              this.setState({ shownPanel: ShownPanelsEnum.None });
            }}
            clickOnSave={() => {
              this.setState({ shownPanel: ShownPanelsEnum.None });
              this.refresh();
            }}
            windowDescription={EditSurveyWindowDescription}
            errorCode='SUR-EDIT'
          />
        )}
      </div>
    );
  }

  renderActionButtonRow() {
    return (
      <FigmaButtonRow
        className={'InnerMenuButtonFigmaList'}
        buttons={[
          {
            iconName: 'fa-solid fa-plus-circle',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Primary,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.showPanel(ShownPanelsEnum.AddNewItem),
            tooltip: 'Create Survey',
            roleKey: 'client_edit',
          },
          {
            iconName: this.state.showAll ? 'fa-regular fa-user' : 'fa-solid fa-users',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.setState({ showAll: !this.state.showAll }),
            tooltip: this.state.showAll ? `Show last ${this.state.numberOfElementConst}` : 'Show All',
          },
        ]}
      />
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderPanels()}
        {this.renderActionButtonRow()}
        <TabOfDataTable
          type={SurveyItemList}
          shownPanel={ShownOverWindowsEnum.None}
          serviceFunction={SurveyService.GetSurveyListByClientId}
          searchItem={this.state.searchItem}
          convertDBItemsFunction={SurveyService.ConvertDBItem}
          changeOfItemListFunction={() => {}}
          maxShownItem={this.state.showAll ? undefined : this.state.numberOfElementConst}
          numberOfElementsOnAPage={1000}
          orderDirection={OrderDirectionsEnum.Desc}
          errorCode='SA161'
        />
      </div>
    );
  }
}

export default SurveyAdmin;
